import type { UnitDetailsData } from '@/core/api/models/properties';
import { unitsService } from '@/core/api/services/unitsService';
import { logger } from '@/core/logger';
import { useAppStore } from '@/core/stores/appStore';
import { buildAdhaCatalogueStoreUpdate } from '@/modules/auth/services/adhaCatalogueSnapshot';

export { mapCatalogueProfileToLoanDetails } from '@/modules/auth/services/adhaCatalogueSnapshot';

/**
 * Replace catalogue-owned store slices with this response.
 * Nothing is merged with the previous project or loan snapshot.
 */
export function applyAdhaCatalogueProfileToStore(details: UnitDetailsData): void {
  const state = useAppStore.getState();
  if (!state.isAdhaJourney || !state.auth.isAuthenticated) {
    return;
  }

  const next = buildAdhaCatalogueStoreUpdate(details, state.auth.user?.loan_Amount);
  state.setAdhaProjectDetails(next.projectDetails);
  state.setAdhaLoanDetails(next.loanDetails);
}

let catalogueRefreshSeq = 0;

/** GET /v1/customers/profile and replace the ADHA catalogue snapshot in the store. */
export async function refreshAdhaCatalogueProfile(): Promise<void> {
  const seq = ++catalogueRefreshSeq;
  const state = useAppStore.getState();
  if (!state.isAdhaJourney || !state.auth.isAuthenticated) {
    return;
  }

  try {
    const response = await unitsService.getUnitDetails();
    if (seq !== catalogueRefreshSeq) {
      return;
    }
    const latest = useAppStore.getState();
    if (!latest.isAdhaJourney || !latest.auth.isAuthenticated) {
      return;
    }
    if (!response.details) {
      logger.warn('AdhaCatalogueProfile:response missing details');
      return;
    }
    applyAdhaCatalogueProfileToStore(response.details);
    logger.info('AdhaCatalogueProfile:store updated', {
      projectId: response.details.project_id,
      amenityCount: response.details.amenities?.length ?? 0,
    });
  } catch (error) {
    if (seq !== catalogueRefreshSeq) {
      return;
    }
    logger.warn('AdhaCatalogueProfile:refresh failed', { error });
  }
}
